import { TimeoutProps } from 'react-transition-group/Transition';
import { ReactElement } from 'react';

export type RenderItem = (
  index: number,
  props?: {
    timeoutProps?: Partial<TimeoutProps<undefined>>;
    itemKey?: (index: number) => string | number;
    index2d?: { rowIndex: number; columnIndex: number };
  },
) => ReactElement | null;
